import { render, staticRenderFns } from "./BusinessOmniplayEventsOrder.vue?vue&type=template&id=525ad08c"
import script from "./BusinessOmniplayEventsOrder.vue?vue&type=script&lang=js"
export * from "./BusinessOmniplayEventsOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports